import classNames from 'classnames';
import { ReactNode, useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from 'yoso';
import { Close } from '~/components/Icon/Close';
import { useBodyScrollLock } from '~/components/Scroll/Scoll.hooks';
import { useSidebarStore } from '~/components/Sidebar/Sidebar.hooks';
import { useUpdateLayoutEffect } from '~/components/Util/react';
import styles from './Sidebar.module.scss';

export type SidebarProps = {
  className?: string;
  children?: ReactNode;
};

export const Sidebar = ({ className, children }: SidebarProps) => {
  const { active, setActive } = useSidebarStore();
  const [playing, setPlaying] = useState<boolean | null>(false);
  const onClose = useCallback(() => {
    setActive(false);
  }, [setActive]);

  const location = useLocation();
  useEffect(() => {
    setActive(false);
  }, [location, setActive]);

  useUpdateLayoutEffect(() => {
    setPlaying(null);
    requestAnimationFrame(() => {
      setPlaying(true);
    });
  }, [active]);

  useBodyScrollLock(active, '#sidebar');

  const onTransitionEnd = useCallback(() => setPlaying(false), []);

  return (
    <div
      id="sidebar"
      className={classNames(styles.root, className, {
        [styles.active]: active,
        [styles.inactive]: !active,
        [styles.playing]: playing === true,
        [styles.done]: playing === false,
      })}
      onTransitionEnd={onTransitionEnd}>
      <div className={styles.backdrop} onClick={onClose} />
      <div className={classNames(styles.sidebar, className)}>
        <Button variant="transparent" className={styles.closeButton} onClick={onClose}>
          <Close />
        </Button>
        {children}
      </div>
    </div>
  );
};
